/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useCallback, useEffect, useState } from 'react';
import axiosCall from '../../services/axios';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';

const useCollectionStatusList = () => {
  const { get } = useAbortController();
  const { token } = useAuthContext();
  const [qidCollectData, setQidCollectData] = useState([]);
  const [qidCollectLoaded, setQidCollectLoaded] = useState(0);

  const getCollectStatusList = useCallback(async () => {
    if (!token) return;
    const url = `live/master/qid/MASK_CD.369/list`;
    const config = get();
    const headers = {
      'Session-Token': token,
    };

    try {
      const data = await axiosCall({ url }, config, headers);
      setQidCollectData(data);
      setQidCollectLoaded(1);
    } catch (e) {
      if (e.code !== 'ERR_CANCELED') {
        console.log(e);
      }
      setQidCollectLoaded(2);
    }
  }, [get, token]);

  useEffect(() => {
    getCollectStatusList();
  }, [getCollectStatusList]);

  return {
    qidCollectData,
    qidCollectLoaded,
  };
};

export default useCollectionStatusList;
